<template>
  <div>
    <!-- Content Row -->
    <b-row align="left">
      <b-col md="8" class="mt-2">
        <h5 class="font-weight-bold text-primary">Error Guide Book</h5>
      </b-col>
      <b-col class="text-right">
        <b-row>
          <b-col>
            <router-link :to="{ name: 'createGuideBook' }">
              <b-button variant="primary">
                <img src="@/assets/create-new.svg" class="mr-2 action_icon" alt />Create New
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row class="mt-4 align-items-end">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search Error Code or Location"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (from)"
                class="font-weight-bold m-0"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col class="p-0 d-flex form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="100%" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="created_date_from"
                      :format="customFormatter"
                      :disabledDates="disableCreatedTo"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetCreatedDateFrom" style="text-decoration: none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (to)"
                class="font-weight-bold m-0"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col class="p-0 d-flex form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="100%" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="created_date_to"
                      :format="customFormatter"
                      :disabledDates="disableCreatedFrom"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetCreatedDateTo" style="text-decoration: none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the moment, please try back
          later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="pxContent"
        hover
        :items="getGuide"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(error_code)="row">
          <div class="text-capitalize">
            <span :class="['4', '5'].includes(row.value[0]) ? 'text-danger' : 'text-success'">
              {{ row.value }}
            </span>
          </div>
        </template>

        <template v-slot:cell(action)="{ value, item }">
          <div class="d-flex align-items-center" style="gap:1rem;">
            <router-link
              :to="{ name: 'editGuideBook', params: { id: item.id } }"
              class="text-primary"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <span @click="deleteGuideBook(item.id)" style="cursor:pointer;">
              <img src="@/assets/rectangle.svg" alt="delete-guide" />
            </span>
          </div>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker
  },
  data() {
    return {
      created_date_from: new Date(Date.now() - 8640000),
      created_date_to: new Date(Date.now()),
      // Show Detail Modal
      loading: false,
      errored: false,
      fields: [
        {
          key: "id",
          label: "Id",
          sortable: false,
          class: "text-center"
        },
        {
          key: "error_code",
          label: "Error Code",
          sortable: false,
          class: "text-center"
        },
        {
          key: "location",
          label: "Location",
          sortable: false,
          class: "text-center"
        },
        {
          key: "description",
          label: "Description",
          sortable: false,
          class: "text-center"
        },
        {
          key: "cause_by",
          label: "Cause By",
          sortable: false,
          class: "text-center"
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: false,
          class: "text-center"
        },
        {
          key: "created_by",
          label: "Created By",
          sortable: false,
          class: "text-center"
        },
        {
          key: "updated_at",
          label: "Updated At",
          sortable: false,
          class: "text-center"
        },
        {
          key: "updated_by",
          label: "Updated By",
          sortable: false,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      error_logs: []
    };
  },
  watch: {
    createdDate: {
      handler: function(newValue) {
        this.triggerGet();
      },
      deep: true
    },
    created_date_from: {
      handler: function(newValue) {
        if (newValue) {
          this.disableCreatedFrom = newValue;
        }
      },
      deep: true
    },
    created_date_to: {
      handler: function(newValue) {
        if (newValue) {
          this.disableCreatedTo = newValue;
        }
      },
      deep: true
    }
  },
  computed: {
    createdDate() {
      return {
        from: this.created_date_from,
        to: this.created_date_to
      };
    },
    disableCreatedFrom: {
      get: function() {
        let date = this.created_date_from ? this.created_date_from : null;
        let disabledDates = {
          to: new Date(date - 8640000),
          from: new Date(Date.now() + 8640000)
        };
        return disabledDates;
      },
      set: function(newValue) {
        this.created_date_from = newValue || "";
      }
    },
    disableCreatedTo: {
      get: function() {
        let date = this.created_date_to ? this.created_date_to : Date.now();
        let disabledDates = {
          from: new Date(date + 8640000)
        };
        return disabledDates;
      },
      set: function(newValue) {
        this.created_date_to = newValue || "";
      }
    }
  },
  methods: {
    resetCreatedDateFrom() {
      this.created_date_from = "";
    },
    resetCreatedDateTo() {
      this.created_date_to = "";
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getGuide(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append(
        "start_date",
        this.created_date_from ? moment(this.created_date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "end_date",
        this.created_date_to ? moment(this.created_date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("GuideBookModule/getGuideBook", formData)
        .then(response => {
          vm.totalRows = response.total_record;
          callback(response.results || []);
          this.loading = false;
          this.error_logs = response.results;
        })
        .catch(error => {
          this.loading = false;
          callback([]);
        });
      return null;
    },
    triggerGet() {
      this.$refs.pxContent.refresh();
    },
    async deleteGuideBook(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("GuideBookModule/deleteGuideBook", id)
            .then(response => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              this.triggerGet();
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500
              });
            });
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style></style>
